module.exports = __webpack_public_path__ + "781c6bf02633cd2679b63415681655d7.MP3";